// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/asset_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Asset, AssetStatus } from "./asset_pb.js";
import { file_transportation_v1_asset } from "./asset_pb.js";
import type { AssetFacilityUpdatedEvent, AssetFillStateChangedEvent, AssetLocationUpdatedEvent } from "./asset_custom_events_pb.js";
import { file_transportation_v1_asset_custom_events } from "./asset_custom_events_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/asset_events.proto.
 */
export const file_transportation_v1_asset_events: GenFile = /*@__PURE__*/
  fileDesc("CiR0cmFuc3BvcnRhdGlvbi92MS9hc3NldF9ldmVudHMucHJvdG8SEXRyYW5zcG9ydGF0aW9uLnYxIucDCgpBc3NldEV2ZW50EjcKB2NyZWF0ZWQYASABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5Bc3NldENyZWF0ZWRFdmVudEgAEjcKB3VwZGF0ZWQYAiABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5Bc3NldFVwZGF0ZWRFdmVudEgAEjcKB2RlbGV0ZWQYAyABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5Bc3NldERlbGV0ZWRFdmVudEgAEkQKDnN0YXR1c19jaGFuZ2VkGAQgASgLMioudHJhbnNwb3J0YXRpb24udjEuQXNzZXRTdGF0dXNDaGFuZ2VkRXZlbnRIABJIChBmYWNpbGl0eV91cGRhdGVkGAUgASgLMiwudHJhbnNwb3J0YXRpb24udjEuQXNzZXRGYWNpbGl0eVVwZGF0ZWRFdmVudEgAEkgKEGxvY2F0aW9uX3VwZGF0ZWQYBiABKAsyLC50cmFuc3BvcnRhdGlvbi52MS5Bc3NldExvY2F0aW9uVXBkYXRlZEV2ZW50SAASSwoSZmlsbF9zdGF0ZV9jaGFuZ2VkGAcgASgLMi0udHJhbnNwb3J0YXRpb24udjEuQXNzZXRGaWxsU3RhdGVDaGFuZ2VkRXZlbnRIAEIHCgVldmVudCI8ChFBc3NldENyZWF0ZWRFdmVudBInCgVhc3NldBgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLkFzc2V0InYKEUFzc2V0VXBkYXRlZEV2ZW50EjAKDnByZXZpb3VzX2Fzc2V0GAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuQXNzZXQSLwoNdXBkYXRlZF9hc3NldBgCIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLkFzc2V0IjwKEUFzc2V0RGVsZXRlZEV2ZW50EicKBWFzc2V0GAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuQXNzZXQirwEKF0Fzc2V0U3RhdHVzQ2hhbmdlZEV2ZW50EicKBWFzc2V0GAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuQXNzZXQSNwoPcHJldmlvdXNfc3RhdHVzGAIgASgOMh4udHJhbnNwb3J0YXRpb24udjEuQXNzZXRTdGF0dXMSMgoKbmV3X3N0YXR1cxgDIAEoDjIeLnRyYW5zcG9ydGF0aW9uLnYxLkFzc2V0U3RhdHVzQkFaP3BhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYW5zcG9ydGF0aW9uL2FwaS92MTt0cmFuc3BvcnRhdGlvbl92MWIIZWRpdGlvbnNw6Ac", [file_transportation_v1_asset, file_transportation_v1_asset_custom_events]);

/**
 * @generated from message transportation.v1.AssetEvent
 */
export type AssetEvent = Message<"transportation.v1.AssetEvent"> & {
  /**
   * @generated from oneof transportation.v1.AssetEvent.event
   */
  event: {
    /**
     * @generated from field: transportation.v1.AssetCreatedEvent created = 1;
     */
    value: AssetCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: transportation.v1.AssetUpdatedEvent updated = 2;
     */
    value: AssetUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: transportation.v1.AssetDeletedEvent deleted = 3;
     */
    value: AssetDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: transportation.v1.AssetStatusChangedEvent status_changed = 4;
     */
    value: AssetStatusChangedEvent;
    case: "statusChanged";
  } | {
    /**
     * @generated from field: transportation.v1.AssetFacilityUpdatedEvent facility_updated = 5;
     */
    value: AssetFacilityUpdatedEvent;
    case: "facilityUpdated";
  } | {
    /**
     * @generated from field: transportation.v1.AssetLocationUpdatedEvent location_updated = 6;
     */
    value: AssetLocationUpdatedEvent;
    case: "locationUpdated";
  } | {
    /**
     * @generated from field: transportation.v1.AssetFillStateChangedEvent fill_state_changed = 7;
     */
    value: AssetFillStateChangedEvent;
    case: "fillStateChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message transportation.v1.AssetEvent.
 * Use `create(AssetEventSchema)` to create a new message.
 */
export const AssetEventSchema: GenMessage<AssetEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_events, 0);

/**
 * @generated from message transportation.v1.AssetCreatedEvent
 */
export type AssetCreatedEvent = Message<"transportation.v1.AssetCreatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;
};

/**
 * Describes the message transportation.v1.AssetCreatedEvent.
 * Use `create(AssetCreatedEventSchema)` to create a new message.
 */
export const AssetCreatedEventSchema: GenMessage<AssetCreatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_events, 1);

/**
 * @generated from message transportation.v1.AssetUpdatedEvent
 */
export type AssetUpdatedEvent = Message<"transportation.v1.AssetUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset previous_asset = 1;
   */
  previousAsset?: Asset;

  /**
   * @generated from field: transportation.v1.Asset updated_asset = 2;
   */
  updatedAsset?: Asset;
};

/**
 * Describes the message transportation.v1.AssetUpdatedEvent.
 * Use `create(AssetUpdatedEventSchema)` to create a new message.
 */
export const AssetUpdatedEventSchema: GenMessage<AssetUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_events, 2);

/**
 * @generated from message transportation.v1.AssetDeletedEvent
 */
export type AssetDeletedEvent = Message<"transportation.v1.AssetDeletedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;
};

/**
 * Describes the message transportation.v1.AssetDeletedEvent.
 * Use `create(AssetDeletedEventSchema)` to create a new message.
 */
export const AssetDeletedEventSchema: GenMessage<AssetDeletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_events, 3);

/**
 * @generated from message transportation.v1.AssetStatusChangedEvent
 */
export type AssetStatusChangedEvent = Message<"transportation.v1.AssetStatusChangedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;

  /**
   * @generated from field: transportation.v1.AssetStatus previous_status = 2;
   */
  previousStatus: AssetStatus;

  /**
   * @generated from field: transportation.v1.AssetStatus new_status = 3;
   */
  newStatus: AssetStatus;
};

/**
 * Describes the message transportation.v1.AssetStatusChangedEvent.
 * Use `create(AssetStatusChangedEventSchema)` to create a new message.
 */
export const AssetStatusChangedEventSchema: GenMessage<AssetStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_events, 4);

